<div class="settings">
  <h2 class="section-title">Gérer les préférences de mon entreprise</h2>

  <div class="settings-card">
    <div class="settings-row">
      <span class="settings-label">
        <strong>Valeur actuelle des titres restaurant :</strong> {{ ticketAmount }} XOF
      </span>
      <button
        type="button"
        class="tp-btn-primary"
        [attr.data-modal-target]="updateTicketValueModalId"
        [attr.data-modal-toggle]="updateTicketValueModalId">
        Modifier
      </button>
    </div>
  </div>
</div>

<app-modal
  [modalId]="updateTicketValueModalId"
  title="Modifier la valeur des titres"
  [fields]="ticketValueFields"
  [formGroup]="ticketForm"
  (formSubmit)="updateTicketAmount($event)">
</app-modal>

<p-toast></p-toast>